<template>
  <div
    class="bg-white rounded-[16px] flex flex-col justify-center items-center text-center font-[500] text-black px-[20px] md:px-[24px] lg:px-[28px] py-[19px] md:py-[24px] lg:py-[28px] text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] w-full md:max-w-2xl md:mx-auto"
  >
    <p class="">
      “So let each one give as he purposes in his heart, not grudgingly or of necessity; for God
      loves a cheerful giver.”
    </p>
    <p class="font-[700]">2 Corinthians 9:7</p>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
* {
  font-family: 'Inter';
}
</style>
